// @ts-nocheck
import HelpTip from './HelpTip'
import './HelpTip.scss'
export default HelpTip
